import { Contact, Layout } from '@rumblefish/ui/Rumblefish23Theme';
import { useRef } from 'react';

import { NextHeadWithMeta } from '../NextHeadWithMeta';
import { Benefits } from './Benefits';
import { Faq } from './Faq';
import { Hero } from './Hero';
import { OurWork } from './OurWork';
import { Testimonial } from './Testimonial';
import { webDevelopmentPageSeo } from './WebDevelopmentPage.seo';
import type { WebDevProps } from './WebDevelopmentPage.types';
import { WebServices } from './WebServices';

export const WebDevelopmentPage = ({ blogPosts, caseStudies }: WebDevProps) => {
  const offerRef = useRef<HTMLDivElement>(null);

  return (
    <Layout blogPosts={blogPosts}>
      <NextHeadWithMeta {...webDevelopmentPageSeo} />

      <Hero />
      <WebServices offerRef={offerRef} />
      <Testimonial />
      <Benefits />
      <OurWork caseStudies={caseStudies} />
      <Faq />
      <Contact
        subtitle="We will answer any questions you may have related to Web Development!"
        color="aquamarine"
      />
    </Layout>
  );
};
